
export enum ShipmentAgendaItemActionCd {
	APPOINTMENT_SET = 'AppointmentSet',
	FINAL_DELIVERY = 'FinalDelivery',
	LOAD = 'Load',
	UNLOAD = 'Unload'}

